const prefix = 'nullstack'

export default prefix
